import { Component, ElementRef, HostListener, OnInit } from '@angular/core';
import { Router, Event, NavigationEnd, ActivatedRoute, UrlTree } from '@angular/router';
import { AuthService } from 'src/app/authentication/services/auth.service';
import { apiRoutes } from 'src/app/constants/apiRoutes';
import { ApiCallMethodsService } from 'src/app/shared/services/api-call-methods.service';
import { SidenavThemeServiceService } from '../../services/sidenav-theme-service/sidenav-theme-service.service';
import { ToggleServiceService } from '../../services/toggle-service/toggle-service.service';
import { Observable, Subscription, map } from 'rxjs';
import { MainService } from 'src/app/main/services/main.service';
import { PermissionService } from 'src/app/shared/services/permission/permission.service';

@Component({
  selector: 'app-side-menu',
  templateUrl: './side-menu.component.html',
  styleUrls: ['./side-menu.component.scss']
})

export class SideMenuComponent implements OnInit {
  isToggled: boolean = false;
  orgId: string;
  userDetails: any;
  companyProfileDetails: any;
  sharingData: Subscription;
  isLoading: boolean = false;
  companyData: any = null;
  orgName: any = null;

  constructor(private router: Router, private apiCallMethodsService: ApiCallMethodsService,
    private authService: AuthService,
    private activatedRoute: ActivatedRoute,
    private toggleService: ToggleServiceService,
    public themeService: SidenavThemeServiceService,
    private mainService: MainService,
    private el: ElementRef,
    public permissionService: PermissionService
  ) {
    this.toggleService.isToggled$.subscribe(isToggled => {
      this.isToggled = isToggled;
    });


    this.userDetails = this.authService.getSessionDetail();

    if (this.userDetails) {
      this.orgId = this.authService.getId();
      setTimeout(() => {
        if (this.mainService.companyProfileDetails) {
          this.companyData = this.mainService.companyProfileDetails?.data[0];
        }

        if (this.mainService.companyData) {
          this.companyData = this.mainService.companyData?.org;
        }


      }, 200);


    }

    this.sharingData = this.mainService.SharingData.subscribe((response: any) => {
      this.isLoading = false;

      if (response.company) {
        this.companyProfileDetails = response?.company?.data[0];

        this.authService.setId(this.orgId);
        this.orgName = this.getOrgName(this.orgId);
      }

      if (response.orgList) {
        this.companyData = response?.orgList?.org;
        const selectedCompany = this.companyData.find(company => company.org_id === this.orgId);
        this.orgName = selectedCompany?.org_name || '';
      };

    });

    this.sessionDetails = this.authService.getSessionDetail();
  }
  sidebarHovered: boolean = false;
  isActivate: boolean = false;
  navigateToRoute(routeToBeNavigated: any) {
    this.router.navigate([routeToBeNavigated])
  }

  onSidebarHover() {
    this.sidebarHovered = true;
  }

  onSidebarLeave() {
    this.sidebarHovered = false;
  }

  getCompanyName() {
    let orgProfileUrl = apiRoutes.orgProfile + '/' + this.userDetails?.user?.user_id;
    this.apiCallMethodsService.get(orgProfileUrl).subscribe((response: any) => {
      this.companyData = response?.org;

      // Find the company with matching orgId
      const selectedCompany = this.companyData.find(company => company.org_id === this.orgId);
      // Set the default orgName based on orgId
      this.orgName = selectedCompany?.org_name || '';
    });
  }
  setSelectedOrg(orgIds: any, orgName: string) {
    this.orgId = orgIds;
    this.orgName = orgName;
    this.authService.setId(orgIds);

    const selectedCompany = this.companyData?.find(company => company.org_id === orgIds);
    if (selectedCompany) {
      if (selectedCompany.org_image_link) {
        localStorage.setItem('orgLogo', selectedCompany.org_image_link);
      } else {
        localStorage.removeItem('orgLogo');
      }
    }

    let sessionDetail = this.authService.getSessionDetail();
    if (sessionDetail && sessionDetail.user) {
      sessionDetail.user.org_id = orgIds;
      if (selectedCompany && selectedCompany.user_id) {
        sessionDetail.user.user_id = selectedCompany.user_id;
      }
      this.authService.setToken(sessionDetail);
    }

    window.location.reload()
  }
  getCompanyDetails() {
    let url = apiRoutes.selectedOrgProfile + '/' + this.orgId;
    this.apiCallMethodsService.get(url).subscribe((response: any) => {
      this.companyProfileDetails = response?.data[0];
      this.authService.setId(this.orgId);
      this.orgName = this.getOrgName(this.orgId);
    });
  }


  getOrgName(orgId: any): Observable<string> {
    let orgProfileUrl = apiRoutes.orgProfile + '/' + this.userDetails?.user?.user_id;

    // Return an observable instead of using subscribe
    return this.apiCallMethodsService.get(orgProfileUrl).pipe(
      map((response: any) => {
        this.companyData = response?.org;
        const selectedCompany = this.companyData.find(company => company.org_id === orgId);

        return selectedCompany?.org_name || '';
      })
    );
  }
  onOrgChange() {
    this.getOrgName(this.orgId).subscribe(orgName => {
      this.setSelectedOrg(this.orgId, orgName);
    });
  }


  panelOpenState = false;
  logout() {
    this.authService.removeToken();
    setTimeout(() => {
      this.router.navigate(['login']);
    }, 200);
  }

  toggle() {
    this.toggleService.toggle();
  }



  isSidebarClosed: any = false;
  isHovered: boolean = false;
  sessionDetails: any = null;


//   toggleExpandTeam(id) {
//     const teamMenu = document.getElementById(id);
//     console.log(id);
    
//     if(id === 'quotation'){
//       teamMenu?.classList.toggle('expand');
//     }else{
//  teamMenu.classList.remove('expand');
//     }
//   }


toggleExpandTeam(id: any) {
  const allMenus = document.querySelectorAll('.main-menu-content');
    allMenus.forEach(menu => menu.classList.remove('expand'));
  if (id === 'quotation') {
    const quotationMenu = document.getElementById('quotation');
    quotationMenu?.classList.toggle('expand');
  }

}





  toggleSidebarCollapse(): void {
    this.isSidebarClosed = !this.isSidebarClosed;
  }

  openSidebarOnHover(): void {
    if (this.isSidebarClosed) {
      this.isHovered = true;
    }
  }

  closeSidebarOnHoverOut(): void {
    if (this.isSidebarClosed) {
      this.isHovered = false;
    }
  }

  closeSidebar() {
    document.querySelector('.sidebar-area').classList.remove('mobile-open');
    document.querySelector('.overlay').classList.remove('mobile-open');
  };

  onNavItemClick() {
    if (window.innerWidth < 992) {
      this.closeSidebar();
    }
  }

 
  
  ngOnInit(): void {
    this.permissionService.loadPermissions().subscribe();
    this.checkSalesDocsExpand(this.router.url);

    this.router.events.subscribe((event: Event) => {
      if (event instanceof NavigationEnd) {
        this.checkSalesDocsExpand(event.urlAfterRedirects || event.url);
      }
    });
  }

  checkSalesDocsExpand(url: string) {
    if (!url) return;
    if (
      url.includes('/sales/quotation-management') ||
      url.includes('/sales/sales-order-management') ||
      url.includes('/sales/proforma-management')
    ) {
      setTimeout(() => {
        const quotationMenu = document.getElementById('quotation');
        if (quotationMenu && !quotationMenu.classList.contains('expand')) {
          quotationMenu.classList.add('expand');
        }
      }, 100);
    }
  }
}
